import React from 'react';

const Logo = () => {
  return (
    <h1 className='font-logo text-3xl bg-clip-text text-transparent bg-gradient-to-r from-brandColor via-logoGradient2 to-logoGradient3'>
      HOMELY
    </h1>
  );
};

export default Logo;
